import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import {
  PermissionFeatureType,
  PermissionService,
} from '@price-management-console/permissions';
import { filter, of, switchMap, take } from 'rxjs';

export const permissionGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot
) => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);
  const requiredFeature = route.data['feature'] as
    | PermissionFeatureType
    | undefined;

  if (!requiredFeature) {
    // This is a developer error, a route using this guard is misconfigured.
    console.error(
      'Permission guard missing required feature in route data for path:',
      route.routeConfig?.path
    );
    return router.createUrlTree(['/unauthorized']);
  }

  // Wait until permissions are finished loading
  return toObservable(permissionService.isLoading).pipe(
    filter((isLoading) => !isLoading),
    take(1),
    switchMap(() => {
      if (permissionService.hasFeatureAccess(requiredFeature)) {
        return of(true); // User has the required feature access, allow activation.
      } else {
        // User does not have access, redirect to the unauthorized page.
        return of(router.createUrlTree(['/unauthorized']));
      }
    })
  );
};
